import { Component, Input, OnInit, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import {Location} from '@angular/common';
import { FormBuilder, FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { DateRange } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable } from 'rxjs';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';

import { RentActions } from 'src/app/common/store/actions/rent.actions';
import { SearchActions } from 'src/app/common/store/actions/search.actions';
import { selectCurrentCar, selectCurrentCarImagesDatas, selectSearchCriteria, selectLoggedInUserData, selectSimilarCarBriefs, selectSameSellerCarBriefs } from 'src/app/common/store/state/app.state';
import { AppConstants } from 'src/app/public/common/constants/app-constants';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { ObjectClass } from 'src/app/public/common/constants/common-basic-data';
import { GeneralBasicData, ObjectSource } from 'src/app/public/common/constants/general-basic-data';
import { RentBasicData, BookingStatus } from '../../constants/rent-basic-data';
import { Booking } from '../../models/booking.model';
import { DealerBasicData, DealerType, PaymentTermOption } from 'src/app/public/account/constants/dealer-basic-data';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { CarBrief } from 'src/app/public/car/models/car-brief.model';
import { CarCriteria } from 'src/app/public/car/models/car-criteria.model';
import { Car } from 'src/app/public/car/models/car.model';
import { FileData } from 'src/app/public/common/models/file-data.model';


@Component({
    selector: 'app-rent-booking',
    templateUrl: './rent-booking.component.html',
    styleUrls: ['./rent-booking.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RentBookingComponent implements OnInit {

  @Input() carId: string = '';
  @Input() offerId: string = '';

  currentUser$: Observable<Dealer>;
  currentUser: Dealer = new Dealer();

  similarCarBriefs$: Observable<CarBrief[]>;
  sameSellerCarBriefs$: Observable<CarBrief[]>;

  similarCarBriefs: CarBrief[] = [];
  sameSellerCarBriefs: CarBrief[] = [];

  isSeller: boolean = false;

  car$: Observable<Car>;
  car: Car = new Car()
  carImagesFolder$: Observable<FileData[] | undefined > ;
  carImage: Blob = new Blob();

  currentBooking: Booking = new Booking();

  insuranceOptionsList = RentBasicData.rentalInsuranceOptions;
  mileageOptionsList = RentBasicData.rentalMileageOptions;

  todayDate: Date;
  tomorrowDate: Date;
  yesterdayDate: Date;
  selectedDateRange: DateRange<Date>;

  searchCriteria$: Observable<CarCriteria>;
  searchCriteriaStartDate = '';
  searchCriteriaEndDate = '';
  
  isEditable = true;

  paymentTermOptions = DealerBasicData.paymentTermOptions;
  currentPaymentTermOptionIndex = 1;

  countries = GeneralBasicData.getAllCountries();
  mobileMoneyOperators = DealerBasicData.mobileMoneyOperators;

  emailRegex = AppConstants.EMAIL_REGEX;
  phoneNumberRegex = AppConstants.PHONE_NUMBER_REGEX;

  defaultDriverAge = 25;

  PAY_NOW_PERCENT = 10;
  DEPOSIT_PERCENT = 30;

  showRatingDetails: boolean = false;

  DealerType = DealerType;

  businessLine = CarBusinessLine.RENT;

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private store: Store, 
    private readonly sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private _location: Location,
    private _formBuilder: FormBuilder) {

        //this.carDocumentsFolder$ = store.select(selectDocumentsFolderByCarId("0"));
        //this.currentFileData$ = store.select(selectCurrentFileData);

      this.todayDate = new Date();
      this.tomorrowDate = new Date(this.todayDate);
      this.yesterdayDate = new Date(this.todayDate);

      this.tomorrowDate.setDate(this.todayDate.getDate()+1);
      this.yesterdayDate.setDate(this.todayDate.getDate()-1);

      this.selectedDateRange = new DateRange<Date>(this.todayDate, this.tomorrowDate);

      this.currentUser$ = store.select(selectLoggedInUserData);
      this.car$ = store.select(selectCurrentCar);
      this.carImagesFolder$ = store.select(selectCurrentCarImagesDatas);
      
      this.searchCriteria$ = store.select(selectSearchCriteria);

      this.currentBooking.driverAgeMin = 25;

      this.similarCarBriefs$ = store.select(selectSimilarCarBriefs);
      this.sameSellerCarBriefs$ = store.select(selectSameSellerCarBriefs);

    }

  ngOnInit(): void {

    this.currentUser$.subscribe(
      (usr: Dealer) => {
        //this.currentImageIndex = 0;
        if(usr != undefined){
          this.currentUser = Object.assign(new Dealer(), usr);
          this.currentBooking.currency = GeneralBasicData.getCountryCurrencyByCode(usr.countryResident)!;
          this.isSeller = (usr !== undefined && usr.username === this.car.providerId);
        }
        //this.store.dispatch(SearchActions.fetchSameSellerCarBriefsSubmit({sellerId: c.sellerId}));

      });

      this.car$.subscribe(
        (car: Car) => {
          //this.currentImageIndex = 0;
          this.car = Object.assign(new Car(), car);
          this.offerId = car.offerId;
          this.carId = car.carId;
          this.currentBooking.currency = this.car.rentDayRate.currency;
          this.isSeller = (this.currentUser.username !== "" && this.currentUser.username === this.car.providerId); 
  
          //this.store.dispatch(SearchActions.fetchSameSellerCarBriefsSubmit({sellerId: c.sellerId}));
  
        });

      this.searchCriteria$.subscribe(
        (criteria) => {
          this.searchCriteriaStartDate = criteria.startDate;
          this.searchCriteriaEndDate = criteria.endDate;
        } 

      );

      this.similarCarBriefs$.subscribe(
        (res: CarBrief[]) =>  {
          this.similarCarBriefs = res.map(c => Object.assign(new CarBrief(), c));
        }
      );
  
      this.sameSellerCarBriefs$.subscribe(
        (res: CarBrief[]) =>  {
          this.sameSellerCarBriefs = res.map(c => Object.assign(new CarBrief(), c));
        }
      );
      

    this.route.queryParams.subscribe(params => {
      this.offerId = params['offerId'] == undefined ? '' : params['offerId'];
      this.carId = params['carId'] == undefined ? '' : params['carId'];
    
      if(this.carId !== '' || this.offerId !== ''){

        this.store.dispatch(SearchActions.fetchCarDetailsAndImagesSubmit({carId: this.carId, offerId: this.offerId, businessLine: this.businessLine! }));
        this.store.dispatch(SearchActions.fetchSimilarCarBriefsSubmit({carId: this.carId, offerId: this.offerId, businessLine: this.businessLine! }));
        this.store.dispatch(SearchActions.fetchSameSellerCarBriefsSubmit({sellerId: this.car.providerId, businessLine: this.businessLine! }));
        
      }        
    });

    this.carImagesFolder$.subscribe(
      (imgdts) => {
          //this.carImagesFolder = imgdts!;
          if(imgdts != undefined){
            this.carImage = imgdts![0]!.blob;
          }
          
      });
  
    this.currentBooking.startDate = this.searchCriteriaStartDate;
    this.currentBooking.endDate = this.searchCriteriaEndDate;

    //this.currentBooking.startDate = this.searchCriteriaStartDate.length > 0 ? this.searchCriteriaStartDate : this.todayDate.toString();
    //this.currentBooking.endDate = this.searchCriteriaEndDate.length > 0 ? this.searchCriteriaEndDate : this.tomorrowDate.toString();
  }

  getCarImage(): any{

    let objectUrl = URL.createObjectURL(this.carImage!);     
    return this.sanitizer.bypassSecurityTrustUrl(objectUrl); 

  }

  updateCurrentPaymentTermOption(index: number){

    console.log(index);
    this.currentPaymentTermOptionIndex = index;
    this.currentBooking.paymentTermOption = this.paymentTermOptions[index].code;
  }

  onInsuranceOptionChange(){

  }

  
  onMileageOptionChange(){

  }

  onWithDriverChange(){
    if(this.currentBooking.withDriver)
      this.currentBooking.customerDriving = false;

  }

  onCustomerDrivingChange(){
    if(this.currentBooking.customerDriving)
      this.currentBooking.withDriver = false;
  }

  onSelectedDatesChange(event: any){
    console.log('hellooo '+event.value);
    
  }

  filterPastDates = (date: Date | null): boolean => {
    return (date! > this.yesterdayDate);
  }

  filterPastDatesAndBookedDates = (date: Date | null): boolean => {

    let available: boolean = true;

    if ( ! (date! > this.yesterdayDate) ) {
      return false;
    } 

    this.car.allBookings.forEach(
      (booking: Booking) => {
        if (booking.endDate >= ""+date!.valueOf() && ""+date!.valueOf()  >= booking.startDate && booking.status != BookingStatus.CANCELLED) {
          available = false;
          return;
        }
      }
    );
    return available;
  }

  dateFormat(dt: string): string{

    return AppFunctions.stringToDate(dt);
  }

  moneyFormat(s: string): string{
    return AppFunctions.numberWithSpaces(s);
  }

  calculateCarAmount(){
    return this.currentBooking.getTotalDuration() * this.car.rentDayRate.amount;
  }

  calculateInsuranceAmount(){
    return this.currentBooking.getTotalDuration() * this.car.rentInsuranceDayRate.amount;
  }

  calculateDriverAmount(){
    return this.currentBooking.getTotalDuration() * this.car.rentDriverDayRate.amount;
  }

  calculateTotalAmount(){
    return this.calculateCarAmount() + this.calculateInsuranceAmount() + (this.calculateDriverAmount()*+this.currentBooking.withDriver)
  }

  calculateAmountToPay() {

    console.log(this.paymentTermOptions[this.currentPaymentTermOptionIndex])

    switch(this.paymentTermOptions[this.currentPaymentTermOptionIndex].code){

      case PaymentTermOption.PAY_ADVANCE : {
        return this.calculateTotalAmount() * (100 - this.DEPOSIT_PERCENT)/100;
      }

      case PaymentTermOption.PAY_NOW : {
        return this.calculateTotalAmount() * (100 - this.PAY_NOW_PERCENT)/100;
      }

      case PaymentTermOption.PAY_LATER : {
        return 0;
      }

      default: {
        return this.calculateTotalAmount();
      }
    }
    
  }

  goToConfirmBookingSubmitOld(){

    console.log(this.currentBooking);

    // this.router.navigate(
    //   ['/rent/booking-validate'],
    //   { queryParams: { id: sellerId } }
    // );

    //this.store.dispatch(RentActions.bookingNewSubmit({carId: this.carId, booking: this.currentBooking  }));
        
  }

  confirmBookingSubmit(){

    //this.currentBooking.carId = this.car.carId;
    this.currentBooking.offerId = this.car.offerId;

    console.log(this.currentBooking);

    this.store.dispatch(RentActions.bookingNewSubmit({ booking: this.currentBooking, objectSource: ObjectSource.RENT}));
        
  }

  getSellerRatingsTotalCount(): number{
    return this.car.providerRatingsSummary.counts == null ? 0 : this.car.providerRatingsSummary.counts!.reduce((a, b) => a + b, 0);
  }

  goToSellerPage(sellerId: string): any{

    this.router.navigate(
      ['/provider-public'],
      { queryParams: { id: sellerId } }
    );
  }

  goToPreviousPage(){
    this._location.back();
  }

  toggleFavorite(): any{

    this.store.dispatch(DealerActions.toggleFavoriteSubmit( { objectId: this.car.offerId !== "" ? this.car.offerId : this.car.carId, objectClass: this.car.offerId !== "" ? ObjectClass.OFFER : ObjectClass.CAR, makeFav: !this.car.favorite, businessLine: CarBusinessLine.RENT}))
  }

}
